module.exports = __webpack_public_path__ + "img/Illustration-09.63fdaa40.png";